import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/log2.png'
import _imports_1 from '@/assets/images/mobile/menu.png'
import _imports_2 from '@/assets/images/mobile/close.png'


const _hoisted_1 = { class: "header-boxs" }
const _hoisted_2 = { class: "header-right" }
const _hoisted_3 = {
  key: 0,
  class: "model-box"
}
const _hoisted_4 = { class: "header-menu-fixed" }
const _hoisted_5 = { class: "menu-top" }
const _hoisted_6 = { class: "menu-list" }
const _hoisted_7 = { class: "sub-menu-list" }

import {onMounted, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router"
import { useStore } from 'vuex';
import { SHOW_DIGITAL_GAME } from '@/views/home/visibility';

export default /*@__PURE__*/_defineComponent({
  __name: 'CCHeader',
  emits: ['clickMenu', 'clickChildMenu'],
  setup(__props, { emit: __emit }) {

const menuListState = ref(false)
const store = useStore();
const router = useRouter();
const route = useRoute()
const emit = __emit

const path = ref('')
watch(() => route.path, (newVal) => {
  path.value = newVal
})
const OnEnter = (event) => {
  if (event.target.children.length === 1) {
    event.target.children[0].classList.remove('normal')
    event.target.children[0].classList.add('highlight')
  }
  event.target.classList.add('hover')
  event.target.classList.add('active')
}

const OnLeave = (event) => {
  if (event.target.children.length === 1) {
    event.target.children[0].classList.remove('highlight')
    event.target.children[0].classList.add('normal')
  }
  event.target.classList.remove('hover')
  event.target.classList.remove('active')
}

const OnClick = (event, id, navIndex = 0) => {
  emit('clickMenu', id)
  menuListState.value = false

  if(router.currentRoute.value.fullPath == '/'){
    // 首页直接跳转到锚点
    emit('clickMenu', id)
  }else {
    // 其他页面跳转到首页再定位锚点
    router.replace({
      path: '/home'
    })
    setTimeout(() => {
      emit('clickMenu', id)
    }, 400)
  }
  store.commit('setProductIndex', Number(navIndex))
}
const JumpContact = () => {
  menuListState.value = false
  router.push({
    path: '/contact-m'
  })
}
const OnClickChild = (event, url: string, navIndex?:number) => {

  menuListState.value = false
  router.replace({
    path: url
  })
  if(navIndex) {
    setTimeout(() => {
      emit('clickMenu', navIndex)
    }, 300)
  }
}

const showMenuList = (state: boolean) => {
  menuListState.value = state
}
const splitPath = () => {
  // console.log('window.location.pathname =====>' + window.location.pathname);
  // console.log('window.location.search =====>' + window.location.search);
  return window.location.pathname.split('/');
}



const openUrl = () => {
  window.open('https://www.walmart.com/global/seller/102762736/cp/shopall?povid=LFNav_Landing%20Page_sellerpage_cat_pill_shopall', '_blank')
  menuListState.value = false

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "header-left",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (OnClickChild($event, '/home')))
      }, [...(_cache[12] || (_cache[12] = [
        _createElementVNode("img", {
          src: _imports_0,
          class: "logo",
          alt: ""
        }, null, -1)
      ]))]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "menu",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showMenuList(true)))
        }, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "",
            class: "menu-icon"
          }, null, -1)
        ]))])
      ])
    ]),
    (menuListState.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "model-bg",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showMenuList(false)))
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[14] || (_cache[14] = _createElementVNode("img", {
                src: _imports_0,
                class: "logo",
                alt: ""
              }, null, -1)),
              _createElementVNode("img", {
                src: _imports_2,
                class: "close",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showMenuList(false))),
                alt: ""
              })
            ]),
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", null, [
                _createElementVNode("div", {
                  class: "menu-item",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (OnClickChild($event, '/home')))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(path.value == '/home' ? 'show' : '')
                  }, "Home", 2)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "sub-menu-item",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (OnClickChild($event, '/home', 1)))
                  }, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("span", null, "Board Game", -1)
                  ]))]),
                  _createElementVNode("div", {
                    class: "sub-menu-item",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (OnClickChild($event, '/home', 2)))
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("span", null, "Crowdfunding Game", -1)
                  ]))]),
                  (_unref(SHOW_DIGITAL_GAME))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "sub-menu-item",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (OnClickChild($event, '/home', 3)))
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("span", null, "Digital Games", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", {
                  class: "menu-item",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (OnClickChild($event, '/team')))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(path.value == '/team' ? 'show' : '')
                  }, "Team", 2)
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", {
                  class: "menu-item",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (OnClickChild($event, '/news')))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(path.value == '/news' ? 'show' : '')
                  }, "News", 2)
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", {
                  class: "menu-item",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (openUrl()))
                }, [...(_cache[18] || (_cache[18] = [
                  _createElementVNode("span", null, "Shop", -1)
                ]))])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", {
                  class: "menu-item",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (OnClickChild($event, '/contact')))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(path.value == '/contact' ? 'show' : '')
                  }, "Contact", 2)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})